<template>
    <!-- Full Page Loading Overlay -->
    <Transition
        enter-active-class="transition-opacity duration-200 ease-out"
        enter-from-class="opacity-0"
        enter-to-class="opacity-100"
        leave-active-class="transition-opacity duration-200 ease-in"
        leave-from-class="opacity-100"
        leave-to-class="opacity-0"
    >
        <div
            v-if="isPageLoading"
            class="fixed inset-0 z-[9999] bg-black/60 backdrop-blur-sm flex items-center justify-center"
        >
            <div class="flex flex-col items-center gap-4">
                <!-- Spinner with custom colors for dark background visibility -->
                <ProgressSpinner
                    style="width: 80px; height: 80px"
                    strokeWidth="4"
                    animationDuration=".8s"
                    fill="transparent"
                    :pt="{
                        root: { class: 'text-white/90' },
                        spinner: { style: 'stroke: currentColor' },
                        circle: { style: 'stroke: currentColor; opacity: 0.3' }
                    }"
                />
                <div class="text-center">
                    <p v-if="pageLoadingMessage" class="text-white text-lg font-medium drop-shadow-lg">
                        {{ pageLoadingMessage }}
                    </p>
                    <p v-else class="text-white text-lg font-medium drop-shadow-lg">
                        {{ $t('Loading...') }}
                    </p>
                    <p class="text-white/80 text-sm mt-1 drop-shadow-lg">
                        {{ $t('Please wait') }}
                    </p>
                </div>
            </div>
        </div>
    </Transition>
</template>

<script setup>
import { useEnhancedLoading } from '@/composables/useEnhancedLoading';
import ProgressSpinner from 'primevue/progressspinner';
import { getCurrentInstance } from 'vue';

const { proxy } = getCurrentInstance();
const $t = proxy.$t;

const { isPageLoading, pageLoadingMessage } = useEnhancedLoading();

</script>
